//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
// import { Logos, logos_list } from '@/containers-ai/Logos';
import { Proof, proofOutcomes } from '@/containers-ai/Proof';

//containers
import {
  Hero,
  LiveInProduction,
  ScenarioTheater,
  AgenticWorkflow,
  Rails,
  EndCTA,
} from './containers/index';

//styles
import { PageWrapper, AIGlobalStyle } from './AI.styles';

function AI() {
  return (
    <PageWrapper>
      <AIGlobalStyle />
      <Navigation theme="dark" />
      <Hero />
      {/* <Logos logos={logos_list} /> */}
      <LiveInProduction />
      <ScenarioTheater />
      <EndCTA variant="top" />
      <AgenticWorkflow />
      <Rails />
      <Proof outcomes={proofOutcomes} />
      <EndCTA variant="bottom" />
      <Footer />
    </PageWrapper>
  );
}

export default AI;
export { AI };
